var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-input", {
        staticStyle: { "margin-bottom": "10px" },
        attrs: { size: "mini", placeholder: "请输入来源名称" },
        model: {
          value: _vm.filterText,
          callback: function ($$v) {
            _vm.filterText = $$v
          },
          expression: "filterText",
        },
      }),
      _c("el-tree", {
        ref: "tree",
        staticClass: "tree-box scrollBars",
        attrs: {
          props: _vm.treeProps,
          data: _vm.treeData,
          "show-checkbox": "",
          "check-strictly": true,
          "node-key": "sourceCode",
          "default-expanded-keys": _vm.defaultExpandedKeys,
          "default-checked-keys": _vm.defaultCheckedKeys,
          "filter-node-method": _vm.filterNode,
        },
        on: {
          "node-click": _vm.handleNodeClick,
          "check-change": _vm.handleCheckChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }